import { defaultTheme } from '@3plearning/react-components';

class ThemeHelper {
  /**
   * If props contains no theme object or the theme object is empty, returns the base theme
   * Otherwise recursively merges props.theme on top of base theme
   */
  static getTheme(props) {
    return props.theme;
  }

  static getDefaultTheme() {
    return defaultTheme;
  }
}

export default ThemeHelper;



// WEBPACK FOOTER //
// ./themes/theme-helper.js